import React, { useRef, useState } from "react";
import "../Styles/OnboardingPage.css";
import { useNavigate } from "react-router-dom";
import { get_profile_by_client_code } from "../api/serverWrapper";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import { saveData } from "../utils/store-data";

export default function OnboardingPage() {
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [codeDigits, setCodeDigits] = useState(Array(6).fill(""));

  const [btnLoading, setBtnLoading] = useState(false);

  const handleInputChange = (e, index) => {
    const value = e.target.value.toUpperCase();

    // If user pastes the full code (e.g. D270CE)
    if (value.length === 6) {
      const chars = value.split("").slice(0, 6);
      setCodeDigits(chars);

      // Auto-focus last input (optional)
      const lastInput = inputRefs.current[5];
      if (lastInput) lastInput.focus();

      return;
    }

    const char = value.slice(0, 1);
    const newDigits = [...codeDigits];
    newDigits[index] = char;
    setCodeDigits(newDigits);

    if (char && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("Text")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");

    if (pastedData.length === 6) {
      const chars = pastedData.split("").slice(0, 6);
      setCodeDigits(chars);

      // Set values in refs (optional, for visual sync)
      chars.forEach((char, idx) => {
        if (inputRefs.current[idx]) {
          inputRefs.current[idx].value = char;
        }
      });

      // Focus the last input
      const lastInput = inputRefs.current[5];
      if (lastInput) lastInput.focus();

      // Optionally auto-submit:
      // setTimeout(() => getProfileByClientCode(), 150);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const openAgents = () => {
    navigate("/browseagents");
  };

  const handleEnterSubmit = async (e) => {
    if (e.key === "Enter") {
      const clientCode = codeDigits.join("");
      if (clientCode.length === 6) {
        setBtnLoading(true);
        await getProfileByClientCode();
        setBtnLoading(false);
      } else {
        alert("Please enter all 6 characters of the code.");
      }
    }
  };

  const getProfileByClientCode = async () => {
    if (btnLoading) {
      return;
    }
    setBtnLoading(true);
    const clientCode = codeDigits.join("");

    if (clientCode.length !== 6) {
      alert("Please enter all 6 characters of the code.");
      return;
    }

    try {
      const resp = await get_profile_by_client_code(clientCode);
      if (resp.data && resp.data.length > 0) {
        // console.log(resp.data[0].IsDeleted);

        let isDeleted = resp.data[0].IsDeleted;

        if (isDeleted) {
          alert("Your Profile is Deleted Please Contact  Your Agent ");
          navigate("/home");
        } else {
          await saveData(USER_ID, resp.data[0].User.UserId);
          await saveData(AGENT_LOGIN, false);
          await saveData(CLIENT_LOGIN, false);
          await saveData(PROFILE_LOGIN, true);
          await saveData(CLIENT_PROFILE_CODE, clientCode);
          navigate("/profileforclient", { state: { client: resp.data[0] } });
        }
      } else {
        alert("No profile found with this code.");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching profile. Please try again.");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div className="onboarding-container">
      {/* Header */}
      <header className="onboarding-header">
        <div className="logo">
          <img
            src={require("../assests/images/agent-login-signup-top-logo.png")}
            alt="Logo"
            className="header-logo"
          />
        </div>
        <a className="signup-link">Sign up</a>
      </header>

      {/* Main Card */}
      <div className="onboarding-card">
        <h2 className="welcome-title">Welcome aboard!</h2>
        <p className="instructions">
          To activate your profile, enter profile code from your agent
        </p>

        {/* Code Inputs */}
        <div style={{ marginLeft: "23%" }} className="code-inputs">
          {codeDigits.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              className="code-box"
              ref={(el) => (inputRefs.current[index] = el)}
              value={digit}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => {
                handleKeyDown(e, index);
                handleEnterSubmit(e); // 👈 ENTER submit
              }}
              onPaste={handlePaste}
            />
          ))}
        </div>

        {/* Join Button */}
        <button className="join-button" onClick={getProfileByClientCode}>
          {btnLoading ? "Loding..." : " Join →"}
        </button>
      </div>

      {/* Agent Browse Option */}
      <div
        className="agent-browse-box"
        onClick={openAgents}
        style={{ cursor: "pointer" }}
      >
        <p className="browse-text">
          No Agent? No problem — browse our trusted agents and pick one to help
          you get started.{" "}
          <div className="browse-link click-effect">Browse Agents →</div>
        </p>
      </div>
    </div>
  );
}
